export default __webpack_public_path__ + "static/media/05.b0ef7721.jpg";